import React from "react";
import * as Style from "./styledHader";
import * as Images from "../data/images";
import * as Comp from "../../../../Components/Form";
import { useSnackbar } from "notistack";
import { useParams } from "react-router-dom";
import AddCoup from "./addCoupon";
import { POST_REQUEST } from "../../../../HooksApi/useApi";
import { USeInsertData } from "../../../../HookAxios/postData";
import { useSelector } from "react-redux";
import { useModalContext } from "~/Provider/ModalProvider";
import { FormControlLabel, RadioGroup } from "@mui/material";
import { useState } from "react";
const Header = ({
  id,
  name,
  disc,
  image,
  rate,
  teacher_name,
  duration,
  cost,
  cost2,
  cost4,
  cost5,
  expiration_month,
  numberRate,
  dateCreate,
  numberStudent,
  hours,
  subscribe,
  apiQuryKey,
}) => {
  const { idCourse } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const token = useSelector((state) => state.Auth.userInfo.token);
  const Disc = useSelector((state) => state.EnrollCourse.discount);
  const code = useSelector((state) => state.EnrollCourse.code);
  const { openLogin } = useModalContext();
  const [subscribed, setSubscribed] = useState(false);
  const {
    mutate: enrollCourse,
    status: StatusEnrollCourse,
    data: dataEnrollCourse,
    error: errorEnrollCourse,
  } = POST_REQUEST({
    request: (data) =>
      USeInsertData("subscribe_to_course", data, {
        Authorization: `Bearer ${token}`,
      }),
    handelOnSettledError,
    handelOnSettledData,
  });
  function handelOnSettledError(error) {
    //enqueueSnackbar(error?.response?.data?.message, { variant: 'error' });
  }
  function handelOnSettledData(data) {
    enqueueSnackbar("تم الاشتراك بالدورة بنجاح", { variant: "success" });
    setSubscribed(true);
  }

  const RadioButton = ({ label, value, ...props }) => {
    return (
      <FormControlLabel
        control={<Style.StyledRadio value={value} />}
        label={label}
        labelPlacement="end"
        {...props}
      />
    );
  };
  const RadioButtonTwo = ({ label, value, ...props }) => {
    return (
      <FormControlLabel
        control={<Style.StyledRadioTwo value={value} />}
        label={label}
        labelPlacement="end"
        {...props}
      />
    );
  };
  const [value, setValue] = React.useState("full");

  const handleChange = (event) => {
    setValue(event.target.value);
  };
  const [value2, setValue2] = React.useState("2");

  const handleChangeTwo = (event) => {
    setValue2(event.target.value);
  };
  React.useEffect(() => {
    if (value === "full") setValue2("");
    else setValue2("2");
  }, [value]);
  return (
    <Style.Section>
      <Style.HeaderFlex>
        <Style.HeaderContent>
          <Style.HeaderText>{name}</Style.HeaderText>
          <Style.DiscText>{disc}</Style.DiscText>
        </Style.HeaderContent>
        <Style.LeftSection>
          <Style.CardSection>
            <Style.CardSectionImage>
              <Style.Img
                style={{ width: "150px", height: "150px" }}
                src={`${process.env.REACT_APP_BASE_URL}${image}`}
              />
            </Style.CardSectionImage>

            {value === "full" ? (
              <Style.CardSectionTextPrice>
                {Disc !== 100 ? (
                  <Style.CardTextPriceDisCount>
                    {cost} نقطة
                  </Style.CardTextPriceDisCount>
                ) : null}

                <Style.CardTextPrice>
                  <pre>
                    {Disc !== 100 ? cost - (cost * Disc) / 100 : cost} نقطة
                  </pre>
                </Style.CardTextPrice>
                {Disc !== 100 ? (
                  <Style.CardTextPrice>حسم {Disc}%</Style.CardTextPrice>
                ) : null}
              </Style.CardSectionTextPrice>
            ) : (
              <Style.CardSectionTextPrice>
                {value2 == 2 ? (
                  <Style.CardTextPrice>
                    <pre>{parseInt(cost2)} نقطة</pre>
                  </Style.CardTextPrice>
                ) : value2 == 4 ? (
                  <Style.CardTextPrice>
                    <pre>{parseInt(cost4)} نقطة</pre>
                  </Style.CardTextPrice>
                ) : (
                  <Style.CardTextPrice>
                    <pre>{parseInt(cost5)} نقطة</pre>
                  </Style.CardTextPrice>
                )}
              </Style.CardSectionTextPrice>
            )}

            <Style.CardSectionTextPrice>
              {/* <Style.CardText color="#E30000" >
                هذا الحسم صالح لمدة 12 ساعة فقط.
              </Style.CardText> */}
            </Style.CardSectionTextPrice>
            <Style.HrCustom />
            <Style.ContentTimeDetails>
              <Style.CardText>
                صلاحية وصول لمدة {expiration_month} شهر.
              </Style.CardText>
              <Style.CardText>
                {duration < 1
                  ? `${Math.ceil(duration * 60)} ثانية`
                  : duration < 60
                    ? `${Math.ceil(duration)} دقيقة`
                    : `${Math.ceil(duration / 60)} ساعة`}
              </Style.CardText>
            </Style.ContentTimeDetails>

            <Style.HrCustom />

            {/* <Style.HrCustom /> */}

            {/* <Style.HrCustom /> */}
            {!subscribe && !subscribed && (
              <>
                {token && <AddCoup />}
                {/* <Style.ContentTimeDetails> */}
                {/* <RadioGroup value={value} onChange={handleChange}>
                    <RadioButton label={'دفع دفعة كاملة'} value='full' />
                    <RadioButton label={<>أو التقسيط على :
                      <RadioGroup style={{ display: 'inline' }} value={value2} onChange={handleChangeTwo}>
                        <RadioButtonTwo disabled={value === 'full'} label={'دفعتين'} value='2' />
                        <RadioButtonTwo disabled={value === 'full'} label={'أربع دفعات'} value='4' />
                        <RadioButtonTwo disabled={value === 'full'} label={'خمس دفعات'} value='5' />
                      </RadioGroup>
                    </>} value='part' />
                  </RadioGroup> */}

                {/* {value === "full" ? null : value2 == 2 ? (
                    <Style.CardTextPrice style={{ fontSize: "12px" }}>
                      سعر كل دفعة بالتقسيط على دفعتان : {parseInt(cost2 / 2)}
                    </Style.CardTextPrice>
                  ) : value2 == 4 ? (
                    <Style.CardTextPrice style={{ fontSize: "12px" }}>
                      سعر كل دفعة بالتقسيط على أربع دفعات :{" "}
                      {parseInt(cost4 / 4)}
                    </Style.CardTextPrice>
                  ) : (
                    <Style.CardTextPrice style={{ fontSize: "12px" }}>
                      سعر كل دفعة بالتقسيط على خمس دفعات : {parseInt(cost5 / 5)}
                    </Style.CardTextPrice>
                  )} */}
                {/* </Style.ContentTimeDetails> */}
                {/* <Style.HrCustom /> */}
                <Comp.MuiButton
                  text="شراء المادة"
                  width="100%"
                  margin="20px 0"
                  onClick={() => {
                    if (token) {
                      enrollCourse({
                        course_id: Number(idCourse),
                        code: code,
                        number_of_payments: "",
                      });
                    } else {
                      openLogin();
                    }
                  }}
                />
              </>
            )}

            {/* <Style.ContentTime>
              <Style.CardTextPrice style={{ fontWight: "500" }}>
                مشاركة هذه الدورة عبر
              </Style.CardTextPrice>
              <Style.ContentTimeSot>
                <Style.IconTimeSot>
                  <Style.Img src={Images.FaceBook} />
                </Style.IconTimeSot>
                <Style.IconTimeSot>
                  <Style.Img src={Images.massnger} />
                </Style.IconTimeSot>
                <Style.IconTimeSot>
                  <Style.Img src={Images.Telgram} />
                </Style.IconTimeSot>
                <Style.IconTimeSot>
                  <Style.Img src={Images.WhatsApp} />
                </Style.IconTimeSot>
              </Style.ContentTimeSot>
            </Style.ContentTime> */}
          </Style.CardSection>
        </Style.LeftSection>
      </Style.HeaderFlex>
    </Style.Section>
  );
};

export default Header;
